// extracted by mini-css-extract-plugin
export default {"root":"Customer_root__Fnd0J","report-links":"Customer_report-links__YNWJA","menu-icon":"Customer_menu-icon__R7VsF"};